"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

import { GradientOutlineButton } from "@/components/design/gradient-outline-button";
import Header from "@/components/design/header";
import Stars from "@/components/design/stars";

import TestimonialCard from "./testimonial-card";

type ItemsType = {
  id: string;
  avatar: string;
  name: string;
  timeAgo: string;
  rating: number;
  text: string;
};

const testimonialData = {
  title: "Opinie",
  basedOn: "Na podstawie {count} opinii",
  cta: "WSZYSTKIE OPINIE",
  avgRating: 4.4,
  totalReviews: 189,
  items: [
    {
      id: "anna",
      avatar: "/webp/oskar.webp",
      name: "Marcel P.",
      timeAgo: "5 miesięcy temu",
      rating: 5,
      text: "Świetna zabawa. Syn zadowolony z urodzin. Serdecznie polecam każdemu rodzicowi zrobienie tu urodzin!",
    },
    {
      id: "marcin",
      avatar: "/webp/mateusz.webp",
      name: "Mateusz J.",
      timeAgo: "tydzień temu",
      rating: 5,
      text: "Wyprawiałem urodziny 12 córki-Powiedziała mi że to jej najlepsze urodziny jakie miała:) Bardzo wszystkim polecam jeżeli planują organizować urodziny dla swojego dziecka.",
    },
    {
      id: "katarzyna",
      avatar: "/webp/arleta.webp",
      name: "Arleta O.",
      timeAgo: "2 tygodnie temu",
      rating: 5,
      text: "Świetne miejsce na organizację urodzin! 😊 100% gwarantowana zabawa. Solenizant zadowolony! 😎 Obsługa bardzo sympatyczna i pomocna. Bardzo dziękujemy i na pewno wrócimy.",
    },
    {
      id: "pawel",
      avatar: "/webp/bartek.webp",
      name: "Nicole M.",
      timeAgo: "2 miesące temu",
      rating: 5,
      text: "Byłam na 2 wycieczkach klasowych i 2 urodzinach i zawsze świetnie się bawiłam. Tylko lepiej nie biegać dla własnego bezpieczeństwa sprawdzałam i uwierzcie mi lepiej nie, obsługa również  profesjonalna gdy ten mały wypadek się zdarzył wiedzieli co robić. Pistolety są ciężkie trzeba mieć to na uwadze jeśli chce się wybrać z młodszą dziewczynką.",
    },
  ],
};

export default function TestimonialSection() {
  const t = useTranslations("staticComponents.testimonialSection");

  const title = t("title", { defaultMessage: testimonialData.title });
  const cta = t("cta", { defaultMessage: testimonialData.cta });

  // Correctly use t() with default messages for numbers, then parse to number
  const avgRating = parseFloat(
    t("avgRating", { defaultMessage: String(testimonialData.avgRating) }),
  );
  const totalReviews = parseInt(
    t("totalReviews", { defaultMessage: String(testimonialData.totalReviews) }),
  );

  // Get the translated string with the `count` variable. This handles the replacement.
  const basedOn = t("basedOn", { count: totalReviews });

  // Explicitly type the items variable to ensure type safety
  const items: ItemsType[] = (t.raw("items") ||
    testimonialData.items) as ItemsType[];

  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-20">
      <Header className="-ml-4">{title}</Header>

      <div className="flex flex-col gap-8">
        {/* rating */}
        <div className="flex flex-col px-1 lg:px-0">
          <div className="flex items-center gap-3">
            <Stars rating={avgRating} />
            <span className="text-p1">{avgRating.toFixed(1)}/5</span>
          </div>
          <span className="text-p1 text-gray-300">{basedOn}</span>
        </div>

        {/* testimonials */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {items.map((item) => (
            <TestimonialCard key={item.id} {...item} />
          ))}
        </div>

        {/* CTA */}
        <a
          href="https://maps.app.goo.gl/BN5PP8thJyqhYgmG7"
          target="_blank"
          rel="noopener noreferrer"
        >
          <GradientOutlineButton className="mx-auto md:mx-0">
            {cta}
          </GradientOutlineButton>
        </a>
      </div>
    </section>
  );
}
